import { render, staticRenderFns } from "./XdocProjectPlanForFbd.vue?vue&type=template&id=5df3b136&scoped=true"
import script from "./XdocProjectPlanForFbd.vue?vue&type=script&lang=ts"
export * from "./XdocProjectPlanForFbd.vue?vue&type=script&lang=ts"
import style0 from "./XdocProjectPlanForFbd.vue?vue&type=style&index=0&id=5df3b136&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df3b136",
  null
  
)

export default component.exports